import React from 'react';
import { Modal, Button } from 'antd';

const FormModal = ({
  title,
  visible,
  disabled,
  loading,
  onSubmit,
  onCancel,
  buttonText,
  showSubmit = true,
  children
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={() => onCancel()}
      maskClosable={false}
      footer={[
        showSubmit &&
        <Button
          key="submit"
          type="primary"
          disabled={disabled}
          loading={loading}
          onClick={() => onSubmit()}
        >
          {buttonText ? buttonText : "Submit"}
        </Button>
      ]}
    >
      {children}
    </Modal>
  )
}

export default FormModal;
